import React, { createContext, useEffect } from "react";
import socket from "./socket";

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    useEffect(() => {
        socket.connect();
        console.log('socket connect');
        socket.onerror = (error) => {
            console.error('WebSocket error:', error);
          };
        return () => {
            socket.disconnect();
            console.log('socket disconnect');
        };
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
